import React from 'react'
import { Select as ChakraSelect } from '@chakra-ui/react'
import {
  As,
  HubStyleObject,
  forwardRef,
  StandardSizes,
} from '@hub/design-system-base'

export interface SelectProps {
  sx?: HubStyleObject
  as?: As
  placeholder?: string
  id?: string
  name?: string
  value?: string
  minHeight?: StandardSizes
  icon?: React.ReactElement<any>
  iconSize?: string
  iconColor?: string
  isDisabled?: React.ComponentProps<typeof ChakraSelect>['isDisabled']
  isInvalid?: React.ComponentProps<typeof ChakraSelect>['isInvalid']
  isReadOnly?: React.ComponentProps<typeof ChakraSelect>['isReadOnly']
  isRequired?: React.ComponentProps<typeof ChakraSelect>['isRequired']
  autoComplete?: React.ComponentProps<typeof ChakraSelect>['autoComplete']
  variant?: 'outline' | 'unstyled' | 'filled' | 'flushed'
  size?: React.ComponentProps<typeof ChakraSelect>['size']
  onChange?: React.ChangeEventHandler
  onBlur?: React.ChangeEventHandler
}

const style = {
  borderColor: 'ghost',
  paddingX: 'spacing-md',
  paddingY: 'spacing-sm',
  borderRadius: 0,
  color: 'licorice',
}
export const Select = forwardRef<SelectProps, typeof ChakraSelect>(
  (
    {
      sx,
      as,
      placeholder,
      id,
      name,
      icon,
      iconSize,
      iconColor,
      isDisabled,
      isInvalid,
      isReadOnly,
      isRequired,
      autoComplete,
      variant,
      size,
      onChange,
      onBlur,
      children,
      value,
      minHeight = 'size-7',
    },
    ref
  ) => (
    <ChakraSelect
      ref={ref}
      as={as}
      sx={{ ...style, ...sx, minHeight }}
      placeholder={placeholder}
      id={id}
      name={name}
      icon={icon}
      iconSize={iconSize}
      iconColor={iconColor}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
      autoComplete={autoComplete}
      variant={variant}
      size={size}
      value={value}
      {...(onChange && { onChange })}
      {...(onBlur && { onBlur })}
    >
      {children}
    </ChakraSelect>
  )
)
